<template>
  <popup-block
    :closeModal="closeModal"
    class="video-modal"
    :shown="opened">
    <iframe
      v-if="src"
      class="video-modal_frame"
      width="100%"
      height="450"
      :src="get_src"
      title="YouTube video player" frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope"
      allowfullscreen/>
  </popup-block>
</template>

<script>
import PopupBlock from "../modules/PopupBlock";
import you_tube_video_mixin from "../../mixins/you_tube_video_mixin";

export default {
  name: 'VideoModal',
  mixins: [you_tube_video_mixin],
  components: {
    PopupBlock
  },
  data() {
    return {
      opened: false,
      src: '',
    }
  },
  methods: {
    openModal(src) {
      this.opened = true
      this.src = src
    },
    clearModalData() {
      this.src = ''
    },
    closeModal() {
      this.opened = false
      this.$emit('closed', true)
      setTimeout(this.clearModalData, 300)
    },
  },
}
</script>
